'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	title: 'Please Update',
	message:
		"We've just made an important update to Code Kingdoms, press OK to refresh and start using the new version."
});
